import { useTheme } from "@mui/material";
import Fieldset from "components/form/Fieldset";
import { NestedField, useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import FormRow from "components/form/FormRow";
import { useEffect } from "react";
import _ from 'lodash'
export default function TTPColetas({ visita, name = "coletas", label = "Coletas", paramItems }) {
    const theme = useTheme()

    let [pontos, setPontos] = useFieldValue(name);
    useEffect(() => {

        if ((!pontos || !pontos.length) && paramItems) {
            let newArrar = []
            paramItems.forEach(p => {
                let str = ""
                str += p.classificacao + ": ";
                str += "(" + p.sinalIntervaloMin + " " + p.intervaloMin + " e ";
                str += p.sinalIntervaloMax + " " + p.intervaloMax + ")";
                str += p.operador === "AND" ? " E " : " OU "
                str += "(" + p.sinalIntervaloMin2 + " " + p.intervaloMin2 + " e ";
                str += p.sinalIntervaloMax2 + " " + p.intervaloMax2 + ")";
                newArrar.push({ classificacao: p.classificacao, classificacaoStr: str })
            })

            console.log("newArrar", newArrar)
            if (!_.isEqual(newArrar, pontos)) {

                setPontos(newArrar)
            }
        }

        return () => {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pontos])

    return (
        <>
            <Fieldset label={label} fullWidth sx={{ "& fieldset": { flex: 1, border: "1px solid", borderColor: theme.palette.grey[400], p: 0 }, }}>
                {(pontos || []).map((p, index) => (
                    <NestedField key={index} prefix={name} index={index}>
                        <FormRow sx={{ p: 2, backgroundColor: index % 2 ? "rgba(161,161,161,0.1)" : "#fff" }}>
                            <TextInput
                                sx={{ "& input": { fontWeight: "bold" } }}
                                name="classificacaoStr"
                                label={"Classificação"}
                                disabled
                            />
                            <div style={{ display: 'flex' }}>
                                <TextInput type="number" name="quantidade" label="QTD. Tolete" />
                                <TextInput disabled name="percentual" label="%" />
                            </div>
                        </FormRow>
                    </NestedField>
                ))}
            </Fieldset>
        </>
    )
}
